import { render } from "./ReviewWrapper.vue?vue&type=template&id=5f7b525e"
import script from "./ReviewWrapper.vue?vue&type=script&lang=js"
export * from "./ReviewWrapper.vue?vue&type=script&lang=js"

import "./ReviewWrapper.vue?vue&type=style&index=0&id=5f7b525e&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/view/review/ReviewWrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f7b525e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f7b525e', __exports__)) {
    api.reload('5f7b525e', __exports__)
  }
  
  module.hot.accept("./ReviewWrapper.vue?vue&type=template&id=5f7b525e", () => {
    api.rerender('5f7b525e', render)
  })

}


export default __exports__